import joi from 'joi';
import { ReferralConfigI18nAttributes } from './types/referral';
import { ReferralConfigInput } from './gamification-api-client';

export const referralConfigSchema = joi.object<ReferralConfigInput>({
  i18nAttributes: joi.object().pattern(
    joi.string(),
    joi.object<ReferralConfigI18nAttributes>({
      link: joi.string().pattern(/{referralCode}/),
    }),
  ),
});
